<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Add New Tax</h5>
                    <form class="forms-sample">
                        <b-form-group label="Tax Name">
                            <b-form-input v-model="tax.name" 
                                          type="text" 
                                          placeholder="Name">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Tax Value">
                            <b-form-input v-model="tax.value" 
                                          type="text" 
                                          placeholder="Value">
                            </b-form-input>
                        </b-form-group>
                        <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Add
                        </b-button>
                        <b-button variant="light" 
                                  v-on:click="handleBtnCancel">
                                  Cancel
                        </b-button>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions } from'vuex'
import { required } from 'vuelidate/lib/validators'
import TaxBaseForm from './TaxBaseForm'
export default{
  name: 'taxaddfrom',
  extends: TaxBaseForm,
  created() {
      this.setAction('taxes/addTaxAction');
  },
  
  methods: {

  }
}
</script>